
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'  // <-- добавляем

const firebaseConfig = {
  apiKey: 'AIzaSyA67kcjBmgK8K5WBex5xXo9PAfZxadZPls',
  authDomain: 'jagu-mook.firebaseapp.com',
  projectId: 'jagu-mook',
  storageBucket: 'jagu-mook.appspot.com', // <-- исправил путь на правильный
  messagingSenderId: '329484327156',
  appId: '1:329484327156:web:87f852d253ca655ada66a1',
  measurementId: 'G-H9M59EJPPH',
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app) 